import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UserDto, UserDtoMapper } from '../../dtos/user.dto';
import { map } from 'rxjs';
import { User } from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class UserHttpService {
  readonly http = inject(HttpClient);

  public getUsers() {
    return this.http
      .get<UserDto[]>('/users')
      .pipe(map(users => users.map(UserDtoMapper)));
  }

  public createUser(user) {
    return this.http.post<User>('/users', user);
  }

  public updateUser(id, user) {
    return this.http.put<User>(`/user/${id}`, user);
  }

  public passwordReset(password) {
    return this.http.post('/password_reset', password);
  }

  public getRefreshToken() {
    return this.http.get('/refresh_token');
  }
}
